import { render, staticRenderFns } from "./MainHome.vue?vue&type=template&id=4345aa43&scoped=true&"
import script from "./MainHome.vue?vue&type=script&lang=js&"
export * from "./MainHome.vue?vue&type=script&lang=js&"
import style0 from "./MainHome.vue?vue&type=style&index=0&id=4345aa43&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345aa43",
  null
  
)

export default component.exports